import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'; // ✅ правильный импорт
import { api } from '../services/api'; 

// 🔥 Хук для поиска рецептов (заменяет fetchFilter)
export const useSearchRecipes = (params) => {
  const { data, isLoading, isFetching, isSuccess, error } = useQuery({
    queryKey: ['recipes', params],
    queryFn: () => api.searchRecipes(params),
    enabled: !!params?.currentPage,
    // 🔥 Дефолтное значение при ошибке
    placeholderData: { data: [], count: 0 }
  });
  
  return {
    recipes: data?.data || [],
    totalCount: data?.count || 0,
    isLoading,
    isFetching,
    isSuccess,
    error,
  };
};

export const useOwnerRecipes = (searchParams) => {
  const { data, isLoading, isFetching, error, isSuccess } = useQuery({
    queryKey: ['ownerRecipe', searchParams],
    queryFn: () => api.searchOwnerRecipes(searchParams),
    enabled: !!searchParams,
    // 🔥 Дефолтное значение при ошибке
    placeholderData: { data: [], count: 0 },

  });
   return {
    ownerRecipe: data?.data || [],
    count: data?.count || 0,
    isLoading,
    isFetching,
    error,
    isSuccess
  };  
};

 
// 🔥 Хук для получения полного рецепта (для редактирования)
export const useFullRecipe = (recipeId) => {  
  return useQuery({
    queryKey: ['recipe', recipeId, 'full'],
    queryFn: () => api.getFullRecipe(recipeId),
    enabled: !!recipeId, // Выполняется только когда есть ID
    //staleTime: 0, // При редактировании всегда получаем свежие данные
  });
};

// 🔥 Хук для сохранения рецепта (создание/обновление)
/*export const useSaveRecipe = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (recipe) => api.saveRecipe(recipe),
    onSuccess: (savedRecipe) => {
      // 1. Обновляем кэш списка рецептов (инвалидируем)
      queryClient.invalidateQueries({ queryKey: ['recipes', 'search'] });
      
      // 2. Обновляем кэш конкретного рецепта
      queryClient.setQueryData(['recipe', savedRecipe._id], savedRecipe);
      
      // 3. Обновляем кэш полного рецепта (для редактирования)
      queryClient.setQueryData(['recipe', savedRecipe._id, 'full'], savedRecipe); 
      // 4. Если рецепт есть в списке на текущей странице - обновляем его
      const currentRecipes = queryClient.getQueryData(['recipes', 'search']);
      if (currentRecipes) {
        const updatedRecipes = {
          ...currentRecipes,
          data: currentRecipes.data?.map(recipe => 
            recipe._id === savedRecipe._id ? savedRecipe : recipe
          )
        };
        queryClient.setQueryData(['recipes', 'search'], updatedRecipes);
       queryClient.setQueriesData(
  { queryKey: ['ownerRecipe'] },
  (oldData) => {
    if (!oldData) return oldData;
    
    // Обновляем данные
    if (Array.isArray(oldData)) {
      return oldData.map(recipe =>
        recipe._id === savedRecipe._id ? savedRecipe : recipe
      );
    }
    
    // Если с пагинацией
    if (oldData.data) {
      return {
        ...oldData,
        data: oldData.data.map(recipe =>
          recipe._id === savedRecipe._id ? savedRecipe : recipe
        )
      };
    }
    
    return oldData;
  }
);
      }
      
      console.log('✅ Рецепт сохранен:', savedRecipe.nameRu);
    }, 
    onError: (error) => {
      console.error('❌ Ошибка сохранения рецепта:', error);
    },
    
    // Опционально: показываем уведомление
    onSettled: () => {
      console.log('Операция сохранения завершена');
    }
  });
};*/

export const useSaveRecipe = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (recipe) => api.saveRecipe(recipe),
    
    onSuccess: (savedRecipe) => {
      console.log('✅ Рецепт сохранен:', savedRecipe.nameRu);
      
      // 🔥 Обновляем все кэши, где есть этот рецепт
      const updateCache = (queryKey) => {
  queryClient.setQueriesData(
    { queryKey, exact: false },
    (oldData) => {
      if (!oldData) return oldData;
      
      // Проверяем, существует ли уже этот рецепт в кэше
      const recipeExists = (recipes) => {
        return recipes.some(r => r._id === savedRecipe._id);
      };
      
      // Пагинированные данные { data: [], count, totalPages }
      if (oldData.data && Array.isArray(oldData.data)) {
        if (recipeExists(oldData.data)) {
          // Обновляем существующий рецепт
          const updatedData = oldData.data.map(recipe =>
            recipe._id === savedRecipe._id ? savedRecipe : recipe
          );
          return { ...oldData, data: updatedData };
        } else {
          // Добавляем новый рецепт в начало списка
          const newData = [savedRecipe, ...oldData.data];
          // Обновляем счетчик
          const newCount = (oldData.count || 0) + 1;
          return {
            ...oldData,
            data: newData,
            count: newCount,
            totalPages: Math.ceil(newCount / (oldData.limit || 15))
          };
        }
      }
      
      // Простой массив
      if (Array.isArray(oldData)) {
        if (recipeExists(oldData)) {
          return oldData.map(recipe =>
            recipe._id === savedRecipe._id ? savedRecipe : recipe
          );
        } else {
          return [savedRecipe, ...oldData];
        }
      }
      
      return oldData;
    }
  );
};
      
      // Обновляем все возможные кэши
      updateCache(['recipes']);
      updateCache(['ownerRecipe']);
      updateCache(['recipes', 'search']);
      // Обновляем кэш конкретного рецепта 
      queryClient.setQueryData(['recipe', savedRecipe._id, 'full'], savedRecipe);
    },
    
    onError: (error) => {
      console.error('❌ Ошибка сохранения:', error);
    },
  });
};
export const useGetSort = () => { 
   const queryKey = ['filter', 'sort'];
  return useQuery({
    queryKey,
    queryFn: () => api.getSort(), 
    // Данные свежие 30 минут
    staleTime: 30 * 60 * 1000,
    // Хранятся в кэше 1 час
    gcTime: 60 * 60 * 1000,
    // Отключаем автоматические перезапросы
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

// 🔥 Хук для удаления рецепта
 export const useDeleteRecipe = (queryKey) => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => api.deleteRecipe(id),
    onSuccess: (_, deletedId) => {
      // Обновляем кэш списка
      // Оптимистичное удаление из списка
      queryClient.setQueryData(['recipes', queryKey], (old) => {
         console.log(deletedId, old)
        if (!old) return old;
       
        const updated = { ...old };
        if (updated.data) {
          console.log(typeof(deletedId), typeof(updated.data[0]._id))
          updated.data = updated.data.filter(recipe => recipe._id !== deletedId);
        }
        
        return updated;
      });
      queryClient.setQueryData(['ownerRecipe', queryKey], (old) => {
        console.log(old)
        if (!old) return old;
        
        const updated = { ...old };
        if (updated.data) {
          updated.data = updated.data.filter(recipe => recipe._id !== deletedId);
        }
        
        return updated;
      });
      // Удаляем отдельный рецепт из кэша
      queryClient.removeQueries({ queryKey: ['recipe', deletedId] });
       
    },
  });
}; 


export const useDeleteRecipeCard = () => {
  const queryClient = useQueryClient(); 
   
  return useMutation({
    mutationFn: (id) => api.deleteRecipe(id),
    onSuccess: (_, deletedId) => {
      // 1. Инвалидируем ВСЕ запросы, связанные с рецептами
      // Это перезапросит все страницы с фильтрами
      queryClient.invalidateQueries({ 
        queryKey: ['recipes'], 
        exact: false,  // Инвалидирует все ключи, начинающиеся с ['recipes']
        refetchType: 'active'
      });
      
      // 2. Инвалидируем запросы владельца
      queryClient.invalidateQueries({ 
        queryKey: ['ownerRecipe'], 
        exact: false 
      });
      
      // 3. Удаляем кэш конкретного рецепта
      queryClient.removeQueries({ queryKey: ['recipe', deletedId, 'full'] });
      
   
    },
  });
};

// 🔥 Хук для лайков/дизлайков
/*export const useToggleLike = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ recipeId, action }) => 
    api.toggleLike({ recipeId, action }),
    onMutate: async ({ recipeId, action }) => {
      // Отменяем запросы в процессе
      await queryClient.cancelQueries({ queryKey: ['recipes'] });
      
      // Сохраняем предыдущее состояние
      const previousRecipes = queryClient.getQueryData(['recipes']);
      
      // Оптимистичное обновление UI
      queryClient.setQueryData(['recipes'], (old) => {
        if (!old) return old;
        
        const updated = { ...old };
        updated.data = updated.data.map(recipe => {
          if (recipe._id === recipeId) {
            const isLike = action === 'like';
            const hasLike = recipe.likes?.includes(userId);
            const hasDislike = recipe.disLikes?.includes(userId);
            
            return {
              ...recipe,
              likes: isLike 
                ? (hasLike ? recipe.likes.filter(id => id !== userId) : [...(recipe.likes || []), userId])
                : (recipe.likes || []).filter(id => id !== userId),
              disLikes: !isLike
                ? (hasDislike ? recipe.disLikes.filter(id => id !== userId) : [...(recipe.disLikes || []), userId])
                : (recipe.disLikes || []).filter(id => id !== userId),
              likesCount: isLike
                ? (hasLike ? (recipe.likesCount || 0) - 1 : (recipe.likesCount || 0) + 1)
                : recipe.likesCount || 0
            };
          }
          return recipe;
        });
        
        return updated;
      });
      
      return { previousRecipes };
    },
    onError: (err, variables, context) => {
      // Откат при ошибке
      if (context?.previousRecipes) {
        queryClient.setQueryData(['recipes'], context.previousRecipes);
      }
    },
    onSettled: () => {
      // После завершения обновляем кэш
      queryClient.invalidateQueries({ queryKey: ['recipes'] });
    },
  });
};*/


// 🔥 Хук для получения ингреиентов для редактирования
export const useIngredients = () => { 
  return useQuery({
    queryKey: ['ingredients', 'full'],
    queryFn: () => api.getIngredients(),
    // 🔥 Данные считаются свежими 30 минут (не будут обновляться)
    staleTime: 30 * 60 * 1000,
    // 🔥 Кэш живет 1 час
    gcTime: 60 * 60 * 1000,
    // 🔥 Не обновляем при монтировании, если есть кэш
    refetchOnMount: false,
    // 🔥 Не обновляем при фокусе окна
    refetchOnWindowFocus: false,
    // 🔥 Не обновляем при восстановлении сети
    refetchOnReconnect: false,
  });
};